import { BookOpenIcon, ZapIcon, type LucideIcon } from 'lucide-react';

export interface Pillar {
  icon: LucideIcon;
  tag: string;
  title: string;
  value: string;
  today: string;
  lead: string;
  items: string[];
}

export const pillars: Pillar[] = [
  {
    icon: BookOpenIcon,
    tag: 'Incluido 📚',
    title: 'Los 11 Tomos del Sistema "Mira y Pita"',
    value: '197€',
    today: 'Hoy: Incluido',
    lead: 'Una colección organizada por curso. Cada sesión base se acompaña de una variante desarrollada, ajustes de participación y rúbrica. Las fichas reúnen objetivo, material, montaje visual, tiempos e indicaciones para dirigir la práctica. Al final de cada tomo encontrarás hojas de apoyo imprimibles para tus registros. Cada curso incluye 30 sesiones base y sus 30 variantes: 60 propuestas por curso, con fichas de 50 minutos. Puedes organizarlas como una secuencia de 30 semanas a dos clases semanales y ajustarla al calendario, al grupo y a la programación de tu centro.',
    items: [
      'TOMO 1 — 1º Primaria: Cuerpo y espacio, control del movimiento, objetos y precisión, cooperación, ritmo y autonomía. Propuestas para aprender a moverse y participar con consignas concretas.',
      'TOMO 2 — 2º Primaria: Orientación corporal, equilibrio, pasos y saltos, control de objetos, cooperación, ritmo y rutas. Actividades con progresión y ajustes para organizar al grupo.',
      'TOMO 3 — 3º Primaria: Coordinación, pases y espacios libres, envíos, retos cooperativos, expresión y orientación. Juegos para practicar, decidir y observar avances.',
      'TOMO 4 — 4º Primaria: Regulación del esfuerzo, ataque y defensa sin contacto, juegos de red, precisión, expresión y orientación. Tareas con decisiones y variantes desarrolladas.',
      'TOMO 5 — 5º Primaria: Baloncesto adaptado, raqueta, disco, composición expresiva y orientación. Sesiones para trabajar espacio, pase, cooperación y juego limpio.',
      'TOMO 6 — 6º Primaria: Autorregulación, balonmano y voleibol adaptados, oposición con distancia, composición en equipo y propuestas para un patio activo.',
      'TOMO 7 — 1º ESO: Activación y control personal, líneas de pase, raqueta adaptada, desplazamientos, expresión y orientación. Sesiones para aumentar la autonomía en la práctica.',
      'TOMO 8 — 2º ESO: Dosificación del esfuerzo, ventaja y ayuda en balonmano, juegos de campo dividido, disco, composición corporal a nivel de suelo y orientación.',
      'TOMO 9 — 3º ESO: Planificación personal, fútbol adaptado, decisiones con raqueta, retos cooperativos, creación expresiva y organización de experiencias activas.',
      'TOMO 10 — 4º ESO: Revisión de un plan personal, autonomía en juegos de invasión, estrategia en pareja, recorridos a nivel de suelo, proyecto expresivo y uso compartido del entorno.',
      'TOMO 11 — 1º Bachillerato: Proyecto personal de práctica, control corporal, elección de variantes, estrategia, raqueta, expresión y diseño de una experiencia activa.'
    ]
  },
  {
    icon: ZapIcon,
    tag: 'Incluido 💪',
    title: 'Los 4 Bonos de Supervivencia Estratégica',
    value: '56,60€',
    today: 'Hoy: Incluido',
    lead: 'Los recursos que hacen que el sistema funcione desde el primer día.',
    items: [
      'Bono #1 — Mapa Flash de Arranque 7 Días: Diagnóstico inicial, cuatro sesiones de inicio y checklist de preparación para la primera semana.',
      'Bono #2 — Kit Visual "Mira y Pita": 14 fichas visuales con montaje y variante, en A4 imprimible y versión móvil.',
      'Bono #3 — Scripts de Explicación en 15 Segundos: 24 consignas breves con ejemplos y plantilla para preparar tus explicaciones.',
      'Bono #4 — Panel Anticaos del Profe de EF: Señales, normas y rutinas imprimibles para organizar entradas, salidas y cambios.'
    ]
  }
];
